// generated/models/createLineItemFeedbackBodyCategory.ts
var CreateLineItemFeedbackBodyCategory = {
  Incorrect_line_item_added: "Incorrect line item added",
  Incorrect_quantity_extracted: "Incorrect quantity extracted",
  Missing_recommendation: "Missing recommendation",
  Other: "Other"
};

export {
  CreateLineItemFeedbackBodyCategory
};
//# sourceMappingURL=chunk-EEXP2MVU.mjs.map